var render = function render(){var _vm=this,_c=_vm._self._c;return _c('autocomplete-field',_vm._b({attrs:{"label":"Organization","options":_vm.orgOptions,"autocomplete":"nope","loading":_vm.orgLoading,"two-line":true},on:{"input":_vm.orgSearch,"select":_vm.orgSelect},model:{value:(_vm.keyword),callback:function ($$v) {_vm.keyword=$$v},expression:"keyword"}},'autocomplete-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }